// @flow

function SomeFn() {}

class SomeClass {}
